import ClientDocumentCard from "./ClientDocumentCard";

export default ClientDocumentCard;